export const SEED_CUSTOMER_CARD = '[CustomerCard] Seed Customer Card';
export const CUSTOMER_CARD_APPLY_STARTED = '[CustomerCard] Apply Started';
export const CUSTOMER_CARD_APPLY_SUCCEEDED = '[CustomerCard] Apply Succeeded';
export const CUSTOMER_CARD_APPLY_FAILED = '[CustomerCard] Apply Failed';
export const CUSTOMER_CARD_CANCELLED = '[CustomerCard] Cancelled';
export const SET_INSURANCE_PROVIDERS = '[CustomerCard] Set Insurance Providers';

// RSAA lifecycle types — dispatched automatically by redux-api-middleware
export const SAVE_PARTICIPANTS_REQUEST = '[CustomerCard] Save Participants Request';
export const SAVE_PARTICIPANTS_SUCCESS = '[CustomerCard] Save Participants Success';
export const SAVE_PARTICIPANTS_FAILURE = '[CustomerCard] Save Participants Failure';

export const SYNC_CUSTOMER_REQUEST = '[CustomerCard] Sync Customer Request';
export const SYNC_CUSTOMER_SUCCESS = '[CustomerCard] Sync Customer Success';
export const SYNC_CUSTOMER_FAILURE = '[CustomerCard] Sync Customer Failure';

export const SWAP_BUYER_COBUYER_REQUEST = '[CustomerCard] Swap Buyer CoBuyer Request';
export const SWAP_BUYER_COBUYER_SUCCESS = '[CustomerCard] Swap Buyer CoBuyer Success';
export const SWAP_BUYER_COBUYER_FAILURE = '[CustomerCard] Swap Buyer CoBuyer Failure';
export const SWAP_BUYER_COBUYER_RESET = '[CustomerCard] Swap Buyer CoBuyer Reset';

export const DROP_CO_BUYER_REQUEST = '[CustomerCard] Drop CoBuyer Request';
export const DROP_CO_BUYER_SUCCESS = '[CustomerCard] Drop CoBuyer Success';
export const DROP_CO_BUYER_FAILURE = '[CustomerCard] Drop CoBuyer Failure';
export const DROP_CO_BUYER_RESET = '[CustomerCard] Drop CoBuyer Reset';

export const SAVE_INSURANCE_REQUEST = '[CustomerCard] Save Insurance Request';
export const SAVE_INSURANCE_SUCCESS = '[CustomerCard] Save Insurance Success';
export const SAVE_INSURANCE_FAILURE = '[CustomerCard] Save Insurance Failure';
